import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import React from 'react';
import { Text } from '../../../../react-components/Text';

interface CreateRouteFieldContainerProps {
  textId?: string;
}
//Text uses label color but body's font size
export const CreateRouteFieldContainer = ({
  textId,
  children,
}: React.PropsWithChildren<CreateRouteFieldContainerProps>) => {
  return (
    <Grid item style={{ display: `contents`, width: `100%` }}>
      <Grid item style={{ display: `flex`, flexDirection: `row`, alignItems: `center` }}>
        <Text style={{ fontSize: `13px` }} variant="label" intlId={textId} />
      </Grid>
      <VSpacer small />
      {children}
    </Grid>
  );
};
